// const technologyOptions = [
//   { value: "react", label: "React" },
//   { value: "angular", label: "Angular" },
//   { value: "vue", label: "Vue.js" },
//   { value: "nodejs", label: "Node.js" },
//   { value: "laravel", label: "Laravel" },
//   { value: "django", label: "Django" },
//   { value: "nextjs", label: "Next.js" },
//   { value: "flutter", label: "Flutter" },
//   { value: "reactnative", label: "React Native" },
//   { value: "mysql", label: "MySQL" },
//   { value: "mongodb", label: "MongoDB" },
//   { value: "postgresql", label: "PostgreSQL" },
//   { value: "aws", label: "AWS" },
//   { value: "firebase", label: "Firebase" },
//   { value: "wordpress", label: "WordPress" },
// ]

import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Input } from "reactstrap";
import axios from "axios";
import configure from "configure";

const StepServices = ({
  services,
  setServices,
  serviceOptions,
  pricingMode,
  setPricingMode,
  readOnly,
  stepLogs,
  allUsers,
}) => {
  const isTechMode = pricingMode === "technology";

  // ── Fetch technologies from API ───────────────────────────────
  const [technologyOptions, setTechnologyOptions] = useState([]);

  useEffect(() => {
    const fetchTechnologies = async () => {
      try {
        const res = await axios.get(`${configure.nodeApi}/show_technologies`, {
          headers: { Accept: "application/json" },
        });
        if (res.data.data.length > 0) {
          const currencyValue = res.data.data[0].currency_value;
          const parsed = typeof currencyValue === "string"
            ? JSON.parse(currencyValue)
            : currencyValue;
          // Each row: { Technology: "React", GBP: 28, USD: 35, ... }
          const opts = parsed.map((row) => ({
            value: row.Technology?.toLowerCase().replace(/\s+/g, ""),
            label: row.Technology,
          }));
          setTechnologyOptions(opts);
        }
      } catch (e) {
        console.error("Failed to fetch technologies:", e.message);
      }
    };
    fetchTechnologies();
  }, []);

  // ── Helpers ───────────────────────────────────────────────────

  const updateService = (serviceValue, field, val) =>
    setServices((prev) =>
      prev.map((s) => (s.value === serviceValue ? { ...s, [field]: val } : s)),
    );

  const handleServiceChange = (selected) => {
    const incoming = selected || [];
    setServices((prev) => {
      const existingMap = Object.fromEntries(prev.map((s) => [s.value, s]));
      return incoming.map((s) =>
        existingMap[s.value]
          ? existingMap[s.value]
          : { ...s, title: "", technologies: [] },
      );
    });
  };

  return (
    <div className="rfp-features">
      {/* Header + toggle */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="rfp-title mb-0">Select Services</h4>
        <div className="rfp-toggle">
          <button
            type="button"
            className={`rfp-toggle-btn ${!isTechMode ? "active" : ""}`}
            // onClick={() => setPricingMode("hourly")}
            onClick={() => !readOnly && setPricingMode("hourly")}
            disabled={readOnly}
          >
            Hourly Rate
          </button>
          <button
            type="button"
            className={`rfp-toggle-btn ${isTechMode ? "active" : ""}`}
            // onClick={() => setPricingMode("technology")}
            onClick={() => !readOnly && setPricingMode("technology")}
            disabled={readOnly}
          >
            Technology Wise
          </button>
        </div>
      </div>

      {/* Services multiselect */}
      <div className="rfp-feature-card mb-4">
        <label className="rfp-label mb-2">
          Services <span className="text-danger">*</span>
        </label>
        <div className="col-md-6 p-0">
          <Select
            isMulti
            isDisabled={readOnly}
            placeholder="Select one or more services..."
            className="basic-multi-select"
            classNamePrefix="select"
            options={serviceOptions}
            value={services}
            onChange={handleServiceChange}
          />
        </div>
      </div>

      {/* Per-service cards — grid of 3 */}
      {services.length > 0 && (
        <div className="row g-3">
          {services.map((svc) => (
            <div key={svc.value} className="col-md-12">
              <div className="rfp-service-card h-100">
                <span className="rfp-svc-badge mb-3 d-inline-block">
                  {svc.label}
                </span>

                {/* <div className="mb-3"> */}
                <div className="row g-3 align-items-end">
                  <div className="col-md-7">
                    <label className="rfp-label mb-1">Title</label>
                    <Input
                      type="text"
                      disabled={readOnly}
                      placeholder="e.g. Zithas Mars CRM..."
                      value={svc.title || ""}
                      onChange={(e) =>
                        updateService(svc.value, "title", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-5">
                    <label className="rfp-label mb-1">Technologies</label>
                    <Select
                      isMulti
                      // isDisabled={readOnly}
                      placeholder={
                        technologyOptions.length === 0
                          ? "Loading..."
                          : "Select technologies..."
                      }
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={technologyOptions}
                      value={svc.technologies || []}
                      onChange={(selected) =>
                        !readOnly &&
                        updateService(svc.value, "technologies", selected || [])
                      }
                      isLoading={technologyOptions.length === 0}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* ── Activity ── */}
          {/* {stepLogs &&
            (stepLogs.saved?.length > 0 ||
              stepLogs.submitted?.length > 0 ||
              stepLogs.approved?.length > 0) && (
              <div className="rfp-activity-log">
                <div className="rfp-activity-log-title">Activity</div>
                <div className="d-flex gap-3 flex-wrap">
                  {stepLogs.saved?.length > 0 && (
                    <div className="rfp-activity-pill">
                      <div className="rfp-activity-icon">
                        {(() => {
                          const user = allUsers?.find(
                            (u) => u.id == stepLogs.saved[0].by,
                          );
                          return user?.avatar ? (
                            <img
                              src={`${configure.apiUrl}${user.avatar}`}
                              alt={user.name}
                              style={{
                                width: 28,
                                height: 28,
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <i className="fas fa-user" />
                          );
                        })()}
                      </div>
                      <div>
                        <div className="rfp-activity-label">Created By</div>
                        <div className="rfp-activity-user">
                          {allUsers?.find((u) => u.id == stepLogs.saved[0].by)
                            ?.name || `User #${stepLogs.saved[0].by}`}
                        </div>
                        <div className="rfp-activity-time">
                          {new Date(stepLogs.saved[0].at).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )} */}
        </div>
      )}

      {services.length === 0 && (
        <div className="rfp-empty">
          No services selected yet. Please select at least one service above.
        </div>
      )}
    </div>
  );
};

export default StepServices;
